import { Component, OnInit, ElementRef, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PowerBIDashboardService, PowerBIDashboardResponse } from '../../powerbi-dashboard.service';
import * as powerbi from 'powerbi-client';

@Component({
  selector: 'app-dashboard-powerbi',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './dashboard-powerbi.component.html',
  styleUrls: ['./dashboard-powerbi.component.scss']
})
export class DashboardPowerBIComponent implements OnInit {
  @ViewChild('powerbiContainer', { static: true }) powerbiContainer!: ElementRef;

  loading = true;
  errorMsg: string | null = null;
  private pbiService: powerbi.service.Service;

  constructor(private dashboardService: PowerBIDashboardService) {
    // Inicialização robusta do SDK do Power BI
    const globalPbi = (window as any)['powerbi'];
    if (globalPbi && globalPbi.embed) {
      this.pbiService = globalPbi;
    } else {
      this.pbiService = new powerbi.service.Service(
        powerbi.factories.hpmFactory,
        powerbi.factories.wpmpFactory,
        powerbi.factories.routerFactory
      );
    }
  }

  ngOnInit(): void {
    // Exemplo: Carregar em modo Admin (sem parâmetros)
    this.carregarDashboard();
  }

  carregarDashboard(empresa?: string, instituicao?: string): void {
    this.loading = true;
    this.errorMsg = null;

    this.dashboardService.obterConfiguracao(empresa, instituicao).subscribe({
      next: (res: PowerBIDashboardResponse) => {
        if (res.retorno.codigo === 200 && res.data) {
          this.renderizarReport(res.data);
        } else {
          this.errorMsg = res.retorno.mensagem;
        }
        this.loading = false;
      },
      error: (err) => {
        this.errorMsg = 'Falha ao conectar com o serviço de BI.';
        this.loading = false;
        console.error(err);
      }
    });
  }

  renderizarReport(data: any): void {
    if (!this.powerbiContainer || !this.powerbiContainer.nativeElement) return;

    // Extrai o pageName da URL enviada pelo C#, se existir
    let targetPage: string | undefined = undefined;
    if (data.iframeUrl && data.iframeUrl.includes('pageName=')) {
      targetPage = data.iframeUrl.split('pageName=')[1].split('&')[0];
    }

    const config: powerbi.IReportEmbedConfiguration = {
      type: 'report',
      id: data.reportId,
      embedUrl: data.iframeUrl,
      accessToken: data.accessToken,
      tokenType: powerbi.models.TokenType.Embed,
      pageName: targetPage, // Garante o direcionamento exato da página (ex: Profissionais)
      settings: {
        layoutType: powerbi.models.LayoutType.Custom,
        customLayout: {
          displayOption: powerbi.models.DisplayOption.FitToPage,
        },
        panes: {
          filters: { expanded: false, visible: false },
          pageNavigation: { visible: false } // Esconde a navegação padrão de abas
        },
        background: powerbi.models.BackgroundType.Transparent
      }
    };

    // Reseta o container e injeta o dashboard com segurança
    this.pbiService.reset(this.powerbiContainer.nativeElement);
    this.pbiService.embed(this.powerbiContainer.nativeElement, config);
  }
}
